import * as AvatarPrimitive from '@radix-ui/react-avatar';
import * as React from 'react';

import { cn } from '@/lib/utils';

const AvatarFallback = ({
  className,
  ref,
  ...props
}: React.ComponentPropsWithoutRef<typeof AvatarPrimitive.Fallback> &
  React.RefAttributes<React.ElementRef<typeof AvatarPrimitive.Fallback>>) => (
  <AvatarPrimitive.Fallback
    ref={ref}
    className={cn('bg-muted flex h-full w-full items-center justify-center rounded-full', className)}
    {...props}
  />
);
AvatarFallback.displayName = AvatarPrimitive.Fallback.displayName;

export { AvatarFallback };
